export const getCartId = () => localStorage.getItem("fpg_cartId");
